import HomadScript from './homad.js'

function plugin (Vue, options) {
    // Exit if the plugin has already been installed.
    if (plugin.installed) return

    const Homad = new Vue({

        data () {
            return {
                loaded: false
            }
        },

        computed: {
        },

        methods: {

            init () {

                var vm = this;

                if(!this.$settings.homad.active) {
                    this.$l.log('$homad plugin was disabled')
                    return
                }

                this.$l.log('$homad plugin loaded')

                this.$manager.vendorGrant('5ede3c3d877afa59e3baa199').then(function(grants){
                    if(grants) {
                        vm.$l.log('HOMAD granted by consent tool (vendorGrant)')

                        if(!vm.loaded) {
                            vm.loaded = true
                            HomadScript();
                            vm.$l.log('$homad script called')
                        }
                    }
                    else {
                        vm.$l.log('HOMAD NOT granted by consent tool (vendorGrant)')
                    }

                })
            },

            onHomadEvent(evt) {
                var eventName = 'hd' + evt.detail.name[0].toUpperCase() + evt.detail.name.substring(1)
                this.$l.log('$homad hdEvent',eventName,evt.detail);
                this.$events.$emit('hdEvent', evt.detail)
                this.$events.$emit(eventName, evt.detail)
            },

            getConfig() {
                return this.$settings.homad.conf
            },

            getAdTag(pos) {
                this.$l.log('$homad - getting adTag',pos);

                var adTag = null;

                switch(pos) {
                    case 'pre':
                        adTag = this.$videoAdSchedule.preroll ? this.$videoAdSchedule.preroll + '&fwd_adb=1' : null;
                        break;

                    case 'mid':
                        adTag = this.$videoAdSchedule.midroll ? this.$videoAdSchedule.midroll + '&fwd_adb=1' : null;
                        break;

                    case 'post':
                        adTag = this.$videoAdSchedule.postroll ? this.$videoAdSchedule.postroll + '&fwd_adb=1' : null;
                        break;

                    default:
                        this.$l.log('$homad - no adTag for that position');
                        return null;
                }

                adTag = adTag.replace('__random-number__', Math.floor(Math.random() * 1000000) + 1 );
                adTag = adTag.replace('__player-width__', this.$jwplayer.getWidth() );
                adTag = adTag.replace('__player-height__', this.$jwplayer.getHeight() );

                this.$l.log('$homad - sending adTag:', adTag);

                return adTag;

            }

        }

    })


    window.getHomadConfig = function() {
        return Homad.getConfig()
    }
    window.getAdTag = function() {
        return Homad.getAdTag()
    }
    window.getAdTagPre = function() {
        return Homad.getAdTag('pre')
    }
    window.getAdTagPost = function() {
        return Homad.getAdTag('post')
    }
    window.getAdTagMid = function() {
        return Homad.getAdTag('mid')
    }

    // fire Homad Events
    window.addEventListener('hdEvent', Homad.onHomadEvent);

    // Homad.init()

    // Extend `Vue.prototype` to include our global event bus.
    Object.defineProperty(Vue.prototype, '$homad', {
        get () {
            return Homad
        }
    })

}

// Check for `window.Vue`
if (typeof window !== 'undefined' && window.Vue) {
    // Install plugin automatically.
    window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/homad/index.js